import React, { FC } from "react";
import { Box, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import { styled } from "@mui/system";

const navItemSelected = {
  background: "var( --kyocera-blue)",
  color: "var(--kyocera-white)",
  borderRadius: "10px",
};

const NavigateItem = styled("div")({
  background: "transparent",
  color: "var(--kyocera-white)",
  marginBottom: "8px",
  height: "40px",
  display: "flex",
  alignItems: "center",
  "& .selected": navItemSelected,
  "& :hover": navItemSelected,

  "& a": {
    display: "flex !important",
    alignItems: "center !important",
    color: "var(--kyocera-dark-grey)",
    height: "100%",
    width: "100%",
    textDecoration: "none",

    "&:hover": {
      textDecoration: "none",
    },
  },
});

type IProps = {
  to: string;
  title: string;
  children: any;
  exact?: boolean;
};



const NavItemComponent = (props: IProps) => {
  return (
    <NavigateItem>
      <NavLink
        to={props.to}
        className={({ isActive }) => (isActive ? "selected" : undefined)}
      >
        <Typography component="span" sx={{ marginX: "1rem !important" }}>
          {props.children}
        </Typography>
        <span>{props.title}</span>
      </NavLink>
    </NavigateItem>
  );
};

export default NavItemComponent;
